import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class LanguageService {
    selectLanguage: string = 'en';
    showAltLanguage: boolean = false;
    constructor() { }
}